import { Fragment, useCallback, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";
import { IomData } from "src/pages/Settings/YachtSetup/VesselParticulars/YachtSetup.types";

import IomInput from "./IomInput";

interface Props {
  iomData: Record<string, IomData>;
}
const IomInputs = ({ iomData }: Props) => {
  const { setValue } = useFormContext();
  const [iom, setIom] = useState(iomData);

  const handleAddField = useCallback(
    (key: string) => {
      const newIom = {
        ...iom,
        [key]: {
          ...iom[key],
          list: [...iom[key].list, ""],
        },
      };
      setIom(newIom);
      setValue("iom", newIom);
    },
    [iom, setValue],
  );

  const handleDeleteField = useCallback(
    (key: string, index: number) => {
      const newIom = {
        ...iom,
        [key]: {
          ...iom[key],
          list: iom[key].list.filter((_, i) => i !== index),
        },
      };
      setIom(newIom);
      setValue("iom", newIom);
    },
    [iom, setValue],
  );

  const handleChangeField = useCallback(
    (key: string, index: number, value: string) => {
      const newIom = {
        ...iom,
        [key]: {
          ...iom[key],
          list: iom[key].list.map((item, i) => (i === index ? value : item)),
        },
      };
      setIom(newIom);
      setValue("iom", newIom);
    },
    [iom, setValue],
  );
  const memoizedIom = useMemo(() => iom, [iom]);
  return (
    <Fragment>
      {Object.entries(memoizedIom).map(([key, data], i) => (
        <IomInput
          key={i}
          data={data}
          dataKey={key}
          onAddField={handleAddField}
          onDeleteField={handleDeleteField}
          onChangeField={handleChangeField}
        />
      ))}
    </Fragment>
  );
};
export default IomInputs;
